export enum UserRole {
    CUSTOMER = 'customer',
    SHOP_OWNER = 'shopOwner',
}
